import axios from 'axios';
import * as moment from 'moment';

import config from '../utils/config';
import * as ActivityActions from '../actions/activity';

import {
  authIdInputValue$,
  emailInputValue$,
} from '../selectors/findUser';
import { currentProductName$ } from '../selectors/product';
import {
  dateStart$,
  dateEnd$,
} from '../selectors/datepickers';

import ReduxAction from '../interfaces/ReduxAction';

const URL = config().activity;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const activity = (): ReduxAction => {
  return (dispatch, getState): void => {
    dispatch(ActivityActions.fetchActivityPending());
    const params = new URLSearchParams();

    function paramsAppender (paramName, paramVal) {
      if (paramVal) {
        return params.append(paramName, paramVal);
      } else {
        return null;
      }
    }

    paramsAppender('customer_id', authIdInputValue$(getState()));
    paramsAppender('customer_email', emailInputValue$(getState()));
    paramsAppender('product', currentProductName$(getState()));
    paramsAppender('date_from', moment(dateStart$(getState())).format('YYYY-MM-DD'));
    paramsAppender('date_to', moment(dateEnd$(getState())).format('YYYY-MM-DD'));

    axios({
      method: 'post',
      url: URL,
      data: params,
    })
      .then(response => {
        dispatch(ActivityActions.fetchActivitySuccess(response.data));
      })
      .catch(error => {
        // @ts-ignore
        dispatch(ActivityActions.fetchActivityError(error));
      });
  };
};
